// extracted by mini-css-extract-plugin
export var nav = "FooterNav-module--nav--4cf7c";
export var navContainer = "FooterNav-module--nav-container--5adc1";